export var IStatus;
(function(IStatus) {
    IStatus["DEFAULT"] = 'default';
    IStatus["LOADING"] = 'loading';
    IStatus["SUCCESS"] = 'success';
    IStatus["ERROR"] = 'error';
})(IStatus || (IStatus = {}));

//# sourceMappingURL=status.js.map